// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/safety-hook-schema',
  type: 'object',
  required: ['id', 'creatorId', 'standardScrewThickness', 'standardScrewLength', 'counterbattenScrewLength', 'minimumScrewDepth'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      nullable: true,
    },
    groupName: {
      type: 'string',
      nullable: true,
    },
    screwType: {
      type: 'string',
      nullable: true,
    },
    safetyHookType: {
      type: 'string',
      nullable: true,
    },
    standardScrewThickness: {
      type: 'integer',
    },
    standardScrewLength: {
      type: 'integer',
    },
    counterbattenScrewLength: {
      type: 'integer',
    },
    minimumScrewDepth: {
      type: 'integer',
    },
    canFastenOnCounterbatten: {
      type: 'boolean',
    },
    screwConnectionMustBeDocumented: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
